import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  AbstractControlDirective,
  FormControlName,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { FormControl, FormGroup } from '@ngneat/reactive-forms';
import { ControlValueAccessor } from '@ngneat/reactive-forms';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  selector: 'digital-platform-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: InputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: InputComponent,
    },
  ],
})
export class InputComponent implements ControlValueAccessor, Validator {
  @Input() control: FormControl<any> | undefined = undefined;
  @Input() form: FormGroup<any> | undefined = undefined;
  @Input() variant = 'base';
  @Input() placeholder = '';
  @Input() name = '';
  @Input() value: string | null = '';
  @Input() id = '';
  @Input() required = false;
  @Input() disabled = false;
  @Input() invalid = false;
  @Input() errorMessage = '';
  @Input() large = false;
  @Input() iconLeft = '';
  @Input() iconRight = '';
  @Input() bg = 'light';
  @Input() fontSize = '18px';

  ngOnInit() {
    // Sync the disabled values
    if (this.disabled) {
      this.control?.disable();
    } else if (this.control?.disabled) {
      this.disabled = true;
    }

    // Sync the invalid values
    if (this.invalid) {
      this.control?.markAsTouched();
      this.control?.setErrors({
        invalid: true,
      });
    } else if (this.control?.invalid) {
      this.invalid = true;
    }
  }

  onChange = (_value: string | null) => {};

  onTouched = () => {
    this.markAsTouched();
  };

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setValue(event: any) {
    this.markAsTouched();
    if (!this.control?.disabled) {
      this.value = event.target.value;
      this.onChange(this.value);
    }
  }

  markAsTouched() {
    if (this.control && !this.control?.touched) {
      this.control.markAsTouched();
    }
  }

  onBlur(): void {
    this.markAsTouched();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }

  isTouchedAndInvalid(): boolean | undefined {
    return this.control?.touched && this.control?.invalid;
  }
}
